import { Col, List, Row, Skeleton } from "antd";
import {
  InputField,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import styles from "./Group.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { memo, useEffect, useState } from "react";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import useWindowDimensions from "../../../../../hooks/useWindowDimensions";
import Modal from "../../../../../components/modal/Modal";
import { useRef } from "react";
import { EventPlanningMiddleware } from "../../../../../Store/Middlewares/EventPlanningMiddleware";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";

const DeleteIcon = (
  <svg
    className={styles.svgIcon}
    viewBox="0 0 27 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_994_32981)">
      <path
        d="M3.11221 7.4851C2.38741 7.4851 1.76038 7.49685 1.13466 7.48249C0.435931 7.46681 -0.0177193 7.02796 0.000531011 6.4167C0.0174777 5.82894 0.455485 5.4136 1.12683 5.40968C3.13828 5.39793 5.14972 5.40576 7.21591 5.40576C7.27197 4.66389 7.30716 3.93769 7.38668 3.21541C7.58483 1.39077 8.45824 0.425548 10.2963 0.338038C12.4942 0.233549 14.7051 0.24661 16.9042 0.348487C18.565 0.425548 19.4254 1.37379 19.617 3.03908C19.703 3.7901 19.7239 4.54895 19.7812 5.40315C19.9872 5.40315 20.2153 5.40315 20.4422 5.40315C22.1942 5.40315 23.9475 5.40054 25.6995 5.40446C26.5208 5.40576 26.9953 5.78846 26.9992 6.43629C27.0044 7.08673 26.5299 7.47726 25.7139 7.48379C25.1325 7.48902 24.5524 7.4851 23.8876 7.4851C23.8876 7.77767 23.8876 8.02844 23.8876 8.28052C23.8863 12.7683 23.8889 17.2561 23.8758 21.7439C23.8732 22.4571 23.825 23.1741 23.7481 23.8847C23.5304 25.883 22.4966 26.9345 20.4917 27.1186C19.3093 27.227 18.1166 27.2492 16.9277 27.2558C14.1575 27.2727 11.3887 27.2675 8.61858 27.2518C7.90682 27.2479 7.19115 27.1996 6.48329 27.1238C4.4888 26.9083 3.44332 25.8674 3.25169 23.8638C3.15653 22.8737 3.12133 21.8746 3.11742 20.878C3.10308 16.6723 3.1109 12.4666 3.1109 8.26093C3.11221 8.02713 3.11221 7.79334 3.11221 7.4851ZM21.8109 7.53212C16.2276 7.53212 10.7265 7.53212 5.23054 7.53212C5.23054 12.6913 5.22924 17.8034 5.23445 22.9155C5.23445 23.2172 5.2866 23.5203 5.33353 23.8194C5.46389 24.6409 5.71287 24.9087 6.53022 25.0288C7.04254 25.1046 7.56267 25.1581 8.0802 25.1594C11.6924 25.1712 15.3047 25.1764 18.917 25.1568C19.5388 25.1529 20.1619 25.0354 20.7798 24.9478C21.24 24.8825 21.5267 24.5939 21.5815 24.1341C21.6728 23.3622 21.7875 22.5864 21.7927 21.8119C21.8188 18.5178 21.807 15.2225 21.8096 11.9285C21.8109 10.4774 21.8109 9.02762 21.8109 7.53212ZM17.689 5.3718C17.6368 4.60773 17.5847 3.88153 17.5391 3.15533C17.5091 2.68513 17.2418 2.42129 16.796 2.41868C14.619 2.40431 12.442 2.39647 10.265 2.43827C10.0186 2.4435 9.61061 2.74129 9.56629 2.96202C9.40856 3.7483 9.37597 4.5594 9.29645 5.3718C12.163 5.3718 14.8771 5.3718 17.689 5.3718Z"
        className={styles.svgIconFill}
      />
      <path
        d="M10.3844 16.3298C10.3844 17.8226 10.3883 19.3155 10.3818 20.8071C10.3792 21.5777 9.99205 22.0401 9.36502 22.0531C8.71583 22.0662 8.30911 21.5882 8.30781 20.7823C8.3039 17.8187 8.3039 14.8551 8.3065 11.8916C8.30781 11.0857 8.71062 10.6051 9.3572 10.6129C10.0025 10.6207 10.3805 11.0948 10.3831 11.9164C10.3883 13.3871 10.3844 14.8578 10.3844 16.3298Z"
        className={styles.svgIconFill}
      />
      <path
        d="M12.4588 16.2613C12.4588 14.8115 12.4562 13.363 12.4601 11.9133C12.4627 11.0917 12.842 10.6189 13.4873 10.6124C14.1365 10.6058 14.5328 11.08 14.5341 11.8937C14.538 14.8572 14.538 17.8208 14.5341 20.7844C14.5328 21.5877 14.1222 22.0683 13.4743 22.0526C12.8459 22.0383 12.4627 21.5785 12.4588 20.804C12.4549 19.2902 12.4588 17.7751 12.4588 16.2613Z"
        className={styles.svgIconFill}
      />
      <path
        d="M16.6186 16.3373C16.6186 14.8444 16.6147 13.3515 16.6199 11.8599C16.6225 11.088 17.0084 10.6256 17.6354 10.6126C18.2859 10.5995 18.6939 11.0775 18.6939 11.8821C18.6978 14.8457 18.6978 17.8093 18.6939 20.7728C18.6926 21.5852 18.295 22.0607 17.6445 22.0528C16.9992 22.045 16.6212 21.5722 16.6186 20.7506C16.616 19.2786 16.6186 17.808 16.6186 16.3373Z"
        className={styles.svgIconFill}
      />
    </g>
    <defs>
      <clipPath id="clip0_994_32981">
        <rect
          width="27"
          height="27"
          fill="white"
          transform="translate(0 0.265625)"
        />
      </clipPath>
    </defs>
  </svg>
);

const EditIcon = (
  <svg
    className={styles.svgIcon}
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3364 1.58691H10.8606C4.67111 1.58691 2.19531 4.06271 2.19531 10.2522V17.6796C2.19531 23.8691 4.67111 26.3449 10.8606 26.3449H18.288C24.4775 26.3449 26.9533 23.8691 26.9533 17.6796V15.2038"
      className={styles.svgIconStroke}
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.5792 2.851L9.82459 12.6056C9.45322 12.977 9.08185 13.7074 9.00757 14.2397L8.47528 17.9657C8.27721 19.315 9.2304 20.2559 10.5797 20.0702L14.3058 19.5379C14.8257 19.4636 15.5561 19.0922 15.9398 18.7209L25.6944 8.96622C27.378 7.28267 28.1702 5.32679 25.6944 2.851C23.2186 0.375199 21.2628 1.16745 19.5792 2.851Z"
      className={styles.svgIconStroke}
      stroke-width="2.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.1758 4.24658C18.5863 5.70417 19.3641 7.03193 20.4349 8.10269C21.5056 9.17345 22.8334 9.95132 24.291 10.3618"
      className={styles.svgIconStroke}
      stroke-width="2.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const groupsArr = [
  {
    name: "Family",
  },
  {
    name: "Groom's Side",
  },
  {
    name: "Bride's Side",
  },
  {
    name: "Friends",
  },
];

const SingleGroup = memo(({ group, deleteGroup }) => {
  const { height, width } = useWindowDimensions();
  return (
    <List
      className={styles.list}
      itemLayout={width > 575 ? "horizontal" : "vertical"}
      dataSource={group}
      renderItem={(item, index) => (
        <List.Item className={styles.listItem}>
          <Col>
            <TextComponent text={item.name} textClass={styles.eventTitle} />
          </Col>
          <Col
            className={styles.icons}
            onClick={() => deleteGroup(item?.id, index)}
          >
            {/* {EditIcon} */}
            {DeleteIcon}
          </Col>
        </List.Item>
      )}
    />
  );
});

const Group = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setloading] = useState(false);
  const [groups, setGroups] = useState(groupsArr);
  const [groupname, setgroupname] = useState("");
  const newGroup = useRef();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const event_id = state?.eventData?.id;
  const Group = useSelector((state) => state.EventPlanningReducer.GuestGroup);
  const timeout = useRef();
  const [search, setsearch] = useState("");

  useEffect(() => {
    setloading(true);
    dispatch(
      EventPlanningMiddleware.guestGroups({ name: "", event_id: event_id })
    ).then(() => {
      setloading(false);
    });
  }, []);

  const onSearch = (val) => {
    setsearch(val);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      dispatch(
        EventPlanningMiddleware.guestGroups({ name: val, event_id: event_id })
      );
    }, 1500);
  };
  const create = () => {
    if (!groupname) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Please enter group name",
        })
      );
    } else {
      dispatch(
        EventPlanningMiddleware.createGuestGroup({
          name: groupname,
          event_id: event_id,
        })
      )
        .then(() => {
          setModalOpen(false);
          setgroupname("");
        })
        .catch(() => {
          setModalOpen(false);
          setgroupname("");
        });
    }
  };
  const deleteGroup = (id, index) => {
    dispatch(EventPlanningMiddleware.deleteGuestGroup({ group_id: id, index }));
  };
  return (
    <>
      <Row className={styles.searchRow} gutter={16}>
        <Col xs={24} sm={16} lg={18}>
          <SearchInput
            placeholder="Search"
            value={search}
            onChange={(e) => onSearch(e.target.value)}
          />
        </Col>
        <Col xs={24} sm={8} lg={6}>
          <SubmitButton
            title="Add New Group"
            outline={true}
            btnClass={styles.searchBtn}
            onClick={() => setModalOpen(true)}
          />
        </Col>
      </Row>
      <Skeleton loading={loading}>
        <SingleGroup group={Group} deleteGroup={deleteGroup} />
      </Skeleton>
      <Modal
        isModalOpen={modalOpen}
        setIsModalOpen={setModalOpen}
        closable={true}
        // pinkBg={true}
        wideModal={true}
        className={styles.modalContent}
      >
        <Row className={styles.titleRow}>
          <TextComponent textClass={styles.title}>
            Create a new group
          </TextComponent>
        </Row>
        <Row className={styles.inputRow}>
          <Col xs={22} sm={18}>
            <InputField
              label="Group Name"
              placeholder="Group Name"
              value={groupname}
              onChange={(e) => setgroupname(e.target.value)}
              // onChange={(e) => (newGroup.current = e.target.value)}
            />
          </Col>
        </Row>
        <Row className={styles.btnRow}>
          <Col xs={22} sm={12}>
            <SubmitButton title="Save Group" onClick={create} />
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default Group;
